export const primaryColor = "var(--primary-color)";
export const secondaryColor = "var(--secondary-color)";
export const primaryTextColor = "var(--primary-text-color)";
export const hintTextColor = "var(--hint-text-color)";
export const successTextColor = "var(--success-text-color)";
export const infoTextColor = "var(--info-text-color)";
export const borderInputColor = "var(--border-input-color)";
export const borderColor = "var(--border-color)";
